import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import styles from './TranslationLayout.module.css';
import { Language } from '../../constants/languages';

interface TranslationLayoutProps {
    languages: Language[];
    selectedLang: Language;
    onLangSelect: (lang: Language) => void;
    translations: Record<string, any>;
    completedCount: number;
    children: ReactNode;
}

const TranslationLayout: React.FC<TranslationLayoutProps> = ({
    languages,
    selectedLang,
    onLangSelect,
    translations,
    completedCount,
    children
}) => {
    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <FontAwesomeIcon icon={faLanguage} className={`${styles.sectionIcon} ${styles.sectionIconPrimary}`} />
                <h2 className={styles.sectionTitle}>Translations</h2>

                <div className={styles.progressWrapper}>
                    <div className={styles.progressHeader}>
                        <span className={styles.progressText}>{completedCount}/{languages.length} Completed</span>
                    </div>
                </div>
            </div>

            <div className={styles.translationLayout}>
                {/* Sidebar List */}
                <div className={styles.sidebar}>
                    <div className={styles.sidebarScrollArea}>
                        {languages.map((lang) => {
                            const isCompleted = !!translations[lang.code]?.name?.trim();
                            return (
                                <button
                                    key={lang.code}
                                    type="button"
                                    className={`${styles.langButton} ${selectedLang.code === lang.code ? styles.langButtonActive : ''}`}
                                    onClick={() => onLangSelect(lang)}
                                >
                                    <div className={styles.langButtonContent}>
                                        <span className={styles.langBadge}>{lang.code}</span>
                                        <span className={styles.langName}>{lang.name}</span>
                                    </div>
                                    {isCompleted && (
                                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkMark} />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Translation Form Area */}
                <div className={styles.detailArea}>
                    <div className={styles.detailHeader}>
                        <div className={styles.detailTitleBox}>
                            <div className={styles.detailCodeLarge}>{selectedLang.code}</div>
                            <div className={styles.detailInfo}>
                                <h3 className={styles.detailTitleText}>{selectedLang.name} Translation</h3>
                            </div>
                        </div>
                        {!!translations[selectedLang.code]?.name?.trim() && (
                            <span className={styles.completedBadge}>Completed</span>
                        )}
                    </div>

                    <div className={styles.transForm}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TranslationLayout;
